import { render } from "./AppInfoPanel.vue?vue&type=template&id=64c707c6&scoped=true"
import script from "./AppInfoPanel.vue?vue&type=script&lang=js"
export * from "./AppInfoPanel.vue?vue&type=script&lang=js"

import "./AppInfoPanel.vue?vue&type=style&index=0&id=64c707c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c707c6"]])

export default __exports__